const Vehicle = {

    // FIELDS
    "premise": 'Premise',
    "parking": 'Parking',
    "vehicle_name": 'Vehicle Name',
    "vehicle_number": 'Vehicle Number',
    "vehicle_type": 'Vehicle Type',
    "vehicle_sticker_number": 'Vehicle Sticker Number',
    "search": 'Search',

    // VEHICLE TYPE OPTIONS
    "two_wheeler": '2 Wheeler',
    "four_wheeler": '4 Wheeler',
    "heavy_vehicle": 'Heavy Vehicle',

    // PAGE HEADER
    "vehicle": 'Vehicle',

    // TABLE HEADERS
    "table_premise": 'PREMISE',
    "table_parking": 'PARKING',
    "table_vehicle_name": 'VEHICLE NAME',
    "table_vehicle_number": 'VEHICLE NUMBER',
    "table_vehicle_type": 'VEHICLE TYPE',
    "table_vehicle_sticker_number": 'STICKER NUMBER',

    // ERROR
    "error_premise": 'Select Premise',
    "error_parking": 'Select Parking',
    "error_vehicle_name": 'Enter Vehicle Name',
    "error_vehicle_number": 'Enter Vehicle Number',
    "error_vehicle_type": 'Select Vehicle Type',
    "error_vehicle_sticker_number": 'Enter Vehicle Sticker Number',
};

export default Vehicle;